import TextField from "@mui/material/TextField"
import { useState } from "react"

import { getEditorData, useNodeUtils } from "../../utils"
import BaseNode, { NoPaddingNodeContainer } from "../BaseNode"

export default function NoteNode(node) {
  const [note, setNote] = useState(getEditorData(node))
  const [focused, setFocused] = useState(false)
  const { updateNodeEditorData } = useNodeUtils()
  const height = focused ? "200px" : "100px"

  function handleTextFieldBlurred() {
    setFocused(false)
    updateNodeEditorData(node, note)
  }

  return (
    <BaseNode node={node} Container={NoPaddingNodeContainer}>
      <TextField
        placeholder="Type here..."
        value={note}
        onChange={(e) => setNote(e.target.value)}
        multiline
        sx={{
          "& .MuiInputBase-root": {
            minHeight: height,
            alignItems: "flex-start",
            p: 2,
          },
          "& .MuiInputBase-input": {
            paddingBlock: "0!important",
            fontSize: "12px",
            fontWeight: 600,
          },
        }}
        onFocus={() => setFocused(true)}
        onBlur={handleTextFieldBlurred}
        fullWidth
        spellCheck={false}
      />
    </BaseNode>
  )
}
